import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import {
  getAvailableMembershipsKey,
  getAvailableMemberships,
} from '../api-client/listing/get-available-memberships'

export default function useAvailableMemberships() {
  const [availableMemberships, setAvailableMemberships] = useState({})

  useQuery({
    queryKey: [getAvailableMembershipsKey],
    queryFn: getAvailableMemberships,
    onSuccess: (data) => {
      setAvailableMemberships(data)
    },
  })

  return { availableMemberships }
}
